import { createStyles, Theme } from '@material-ui/core';
import * as Yup from 'yup';

import { hexIdValidator } from '~utils/validators';

export const documentTypeOptions = ['CSV', 'PDF', 'XLS'];

export const alarmTypeOptions = [
  { label: 'All Alarms', value: 'ALL' },
  { label: 'Unrestored only', value: 'UNRESTORED' },
  { label: 'Unacknowledged only', value: 'UNACKNOWLEDGE' }
];

export const validationSchema = Yup.object().shape({
  businessUnitId: Yup.number(),
  subscriberId: hexIdValidator('Subscriber ID should be a HEX decimal between 0x0001 and 0xFFFF'),
  fromDate: Yup.string().required('From Date is a required field'),
  alarmType: Yup.string(),
  documentType: Yup.string(),
});

export const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    content: {
      paddingBottom: spacing(0),
    },
    submitBtn: {
      maxHeight: '40px',
    },
    loader: {
      marginLeft: spacing(1),
    },
  });
